// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/home/inex/Dev/GPM-share/gatsby/src/pages/index.js")
}

exports.json = {
  "index.json": require("gatsby-module-loader?name=path---index!/home/inex/Dev/GPM-share/gatsby/.cache/json/index.json")
}

exports.layouts = {

}


// WEBPACK FOOTER //
// ./.cache/async-requires.js